import React from "react";
import InfoSection from "@components/pages/info/info_section";
import ServiceHeader from "@components/pages/info/services/service_header";
import Head from "next/head";
import {
    ISLAND_ID,
    LOGIN_PATH,
    SMS_ACCESS_PRICE,
    SMS_SEGMENT_PRICE,
    WEBPAGE_TITLE,
} from "@utils/constants";
import { FlexContainer } from "@components/ui/flex_container";

function ServiceNumber() {
    const formattedSMSAccessPrice = SMS_ACCESS_PRICE.toString().replace(
        /\B(?=(\d{3})+(?!\d))/g,
        "."
    );
    return (
        <>
            <Head>
                <title key="site_title">SMS gátt - {WEBPAGE_TITLE}</title>
            </Head>
            <InfoSection containerStyle={{ padding: 30, marginTop: 5 }}>
                <ServiceHeader image="/img/thjonusta/sms-gatt.png" title="SMS gátt" />
                <p>
                    Þarftu að koma skilaboðum áleiðis til viðskiptavina eða að senda út tilboð? 1819
                    býður upp á þægilegt viðmót þar sem fyrirtæki geta sent skilaboð á viðskiptavini
                    eða starfsmenn. Hægt er að nýta þjónustuna á fjölbreyttan máta - allt frá því að
                    senda viðskiptavinum upplýsingar um tímapantanir yfir í að senda ákveðnum hópi
                    sérsniðin tilboð um vörur og þjónustu. Smáskilaboðasendingar eru okkar fag!
                </p>

                <h4>
                    <strong>Helstu eiginleikar SMS gáttarinnar</strong>
                </h4>
                <div style={{ marginLeft: 10 }}>
                    <h5>
                        <strong>Stök skilaboð</strong>
                    </h5>
                    <div>
                        <p
                            style={{
                                fontWeight: 600,
                                color: "#444",
                                marginBottom: 0,
                            }}
                        >
                            Er pöntun tilbúin hjá þér og þarftu að láta viðskiptavininn vita undir
                            formerkjum fyrirtækisins?
                        </p>
                        <p>
                            SMS gátt 1819 er hægt að nota til þess að senda skilaboð á einn eða
                            fleiri í einu.
                        </p>
                    </div>
                    <FlexContainer
                        justifyContent="center"
                        style={{ marginBottom: 50, marginTop: 50, overflow: "visible" }}
                    >
                        <img
                            src="/img/sms-gatt-send.png"
                            style={{
                                width: "75%",
                                filter: "drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.2))",
                            }}
                        />
                    </FlexContainer>
                    <h5>
                        <strong>SMS sendingar á hópa (hóp SMS)</strong>
                    </h5>
                    <div>
                        <p
                            style={{
                                fontWeight: 600,
                                color: "#444",
                                marginBottom: 0,
                            }}
                        >
                            Ertu með lista af símanúmerum, s.s. félagsmenn eða viðskiptavini og vilt
                            senda þeim skilaboð?
                        </p>
                        <p>
                            Í SMS gáttinni getur þú vistað lista af símanúmerum, s.s. símanúmer
                            félagsmanna, viðskiptavina eða annarra og sent skilaboð til allra í
                            einu.
                        </p>
                        <p>
                            Athugið að samkvæmt fjarskiptalögum er einungis heimilt að senda
                            fjöldaskilaboð til þeirra sem hafa samþykkt að fá slík skilaboð. Sem
                            þýðir að hver og einn viðtakandi þarf að hafa veitt þínu fyrirtæki
                            samþykki sitt til að leyfilegt sé að senda á hann skilaboð.
                        </p>
                    </div>
                    <FlexContainer
                        justifyContent="center"
                        style={{ marginBottom: 50, marginTop: 50, overflow: "visible" }}
                    >
                        <img
                            src="/img/sms-gatt-list.png"
                            style={{
                                width: "60%",
                                filter: "drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.2))",
                            }}
                        />
                    </FlexContainer>
                    <div>
                        <p>
                            Þú getur síðan séð stöðu sendingarinnar. Hver fékk SMS-ið og hver ekki.
                        </p>
                    </div>

                    <FlexContainer
                        justifyContent="center"
                        style={{ marginBottom: 50, marginTop: 50, overflow: "visible" }}
                    >
                        <img
                            src="/img/sms-gatt-multiple.png"
                            style={{
                                width: "90%",
                                filter: "drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.2))",
                            }}
                        />
                    </FlexContainer>

                    <h5>
                        <strong>Tímasett skilaboð</strong>
                    </h5>
                    <div>
                        <p
                            style={{
                                fontWeight: 600,
                                color: "#444",
                                marginBottom: 0,
                            }}
                        >
                            Þarftu að minna viðskiptavininn þinn á að hann eigi tíma á morgun?
                        </p>
                        <p>
                            Í SMS gáttinni getur þú tímastillt skilaboðin þannig að þau skili sér í
                            síma viðskiptavinarins á hádegi daginn áður.
                        </p>
                    </div>

                    <div>
                        <p
                            style={{
                                fontWeight: 600,
                                color: "#444",
                                marginBottom: 0,
                            }}
                        >
                            Þarftu að senda út tilboð á ákveðnum tíma, eða þarftu að minna
                            félagsmenn á fund?
                        </p>
                        <p>
                            Hægt er að tímasetja fjöldasendingar þannig að skilaboðin skili sér í
                            síma viðtakenda á þeim tíma sem þú skilgreinir.
                        </p>
                    </div>
                    <FlexContainer
                        justifyContent="center"
                        style={{ marginBottom: 50, marginTop: 50, overflow: "visible" }}
                    >
                        <img
                            src="/img/sms-gatt-timing.png"
                            style={{
                                width: "60%",
                                filter: "drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.2))",
                            }}
                        />
                    </FlexContainer>
                    <h5>
                        <strong>Tenging við vefþjónustur (API)</strong>
                    </h5>
                    <div>
                        <p
                            style={{
                                fontWeight: 600,
                                color: "#444",
                                marginBottom: 0,
                            }}
                        >
                            Vilt þú geta sent SMS skilaboð úr kerfinu þínu?
                        </p>
                        <p>
                            Við bjóðum upp á vefþjónustuskil (API) sem gerir þér kleift að senda SMS
                            úr þínum hugbúnaði, hvort sem um er að ræða staðfestingar á bókunum,
                            viðvaranir, eða skilaboð til starfsmanna. Þitt er valið!
                        </p>
                    </div>

                    <h5>
                        <strong>Lengd skeyta</strong>
                    </h5>
                    <p>
                        Hámarks fjöldi stafa í einu SMS skilaboði eru 160 stafir. Séu notaðir
                        séríslenskir stafir, lækkar fjöldi stafa niður í 70. Ef sent er skilaboð sem
                        er lengra en leyfilegt er, skiptist skilaboðið upp í einingar, sem er svo
                        móttekið af símtækinu sem eitt skilaboð. Greitt er fyrir hverja einingu.
                    </p>
                    <h5>
                        <strong>Notkun SMS gáttar</strong>
                    </h5>
                    <p>
                        Skráðu þig í SMS gátt 1819 hér að neðan. Við munum svo fara yfir umsóknina
                        og opna fyrir SMS gáttina.
                    </p>
                    <p>
                        Fyrirtæki getur gefið starfsfólki sínu aðgang að SMS gáttinni með því að
                        gefa upp kennitölur þeirra. Þá getur starfsfólk skráð sig inn með sínum
                        rafrænu skilríkjum eða Auðkennisappi.
                    </p>
                    <h5>
                        <strong>Greiðslufyrirkomulag</strong>
                    </h5>
                    <p>
                        Hver SMS eining sem send er úr SMS gátt 1819 kostar {SMS_SEGMENT_PRICE} kr.
                        (án virðisaukaskatts) og greitt er fyrir þá þjónustu mánaðarlega.
                        Mánaðargjald fyrir aðgang að SMS gátt er {formattedSMSAccessPrice} kr. (án
                        virðisaukaskatts).
                    </p>
                    <h5>
                        <strong>Hvernig skrái ég mig?</strong>
                    </h5>
                    <p>
                        Þú smellir á takkann hér að neðan og skráir þig inn á Mitt 1819. Næst
                        smellir þú á 'Skrá fyrirtæki í SMS gátt' og fyllir út formið þar. Eftir að
                        þú skráir þig munum við fara yfir skráninguna og opna fyrir aðgang að SMS
                        gáttinni.
                    </p>
                </div>
                <p style={{ textAlign: "center", marginTop: 50 }}>
                    <a className="btn btn-primary" href={LOGIN_PATH}>
                        Innskráning í Mitt 1819
                    </a>
                </p>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
